import { httpClient } from '@/shared/services';
import type {
  Retailer,
  RetailersListResponse,
  RetailerFilters,
  CreateRetailerDTO,
  UpdateRetailerDTO,
  BulkUpdateRetailersDTO,
  RetailerImportResult,
} from '../types/retailers.types';

export const retailersService = {
  list: async (filters: RetailerFilters = {}): Promise<RetailersListResponse> => {
    const params = new URLSearchParams();
    if (filters.page) params.append('page', filters.page.toString());
    if (filters.limit) params.append('limit', filters.limit.toString());
    if (filters.search) params.append('search', filters.search);

    const response = await httpClient.get<RetailersListResponse>(
      `/v1/retailers?${params}`
    );
    return response.data;
  },

  getById: async (retailerId: string): Promise<Retailer> => {
    const response = await httpClient.get<Retailer>(`/v1/retailers/${retailerId}`);
    return response.data;
  },

  create: async (data: CreateRetailerDTO): Promise<Retailer> => {
    const response = await httpClient.post<Retailer>('/v1/retailers', data);
    return response.data;
  },

  update: async (retailerId: string, data: UpdateRetailerDTO): Promise<Retailer> => {
    const response = await httpClient.put<Retailer>(
      `/v1/retailers/${retailerId}`,
      data
    );
    return response.data;
  },

  delete: async (retailerId: string): Promise<void> => {
    await httpClient.delete(`/v1/retailers/${retailerId}`);
  },

  bulkUpdate: async (data: BulkUpdateRetailersDTO): Promise<{ success: boolean; count: number }> => {
    const response = await httpClient.put<{ success: boolean; count: number }>(
      '/v1/retailers/bulk',
      data
    );
    return response.data;
  },

  uploadToR2: async (retailerId: string): Promise<{ success: boolean; url: string }> => {
    const response = await httpClient.post<{ success: boolean; url: string }>(
      `/v1/retailers/${retailerId}/r2/upload`
    );
    return response.data;
  },

  exportExcel: async (): Promise<Blob> => {
    return httpClient.getBlob('/v1/retailers/export/excel');
  },

  importExcel: async (file: File): Promise<RetailerImportResult> => {
    const response = await httpClient.postFile<RetailerImportResult>(
      '/v1/retailers/import/excel',
      file
    );
    return response.data;
  },

  downloadTemplate: async (): Promise<Blob> => {
    return httpClient.getBlob('/v1/retailers/template/excel');
  },
};
